import React from "react"
import Skeleton from "react-loading-skeleton"
import DynamicSkeleton from "../../components/DynamicSkeleton"

const columnConfig = {
  'Station ID': { content: <Skeleton width="100px" />, center: true },
  'Station Name': { content: <Skeleton height="20px" width="200px" />, center: true },
  'Base Fee(₹)': { content: <Skeleton height="30px" width="30px" />, center: true },
  'Parking Fee(₹)': { content: <Skeleton height="30px" width="30px" />, center: true },
  'Convenience Fee(₹)': { content: <Skeleton height="30px" width="30px" />, center: true },
  Action: {
    content: (
      <div className="d-flex justify-content-center gap-2">
        <Skeleton height="30px" width="30px" />
        <Skeleton height="30px" width="30px" />
      </div>
    ),
    center: true,
  },
}

const FeeSkeleton = ({ infiniteScroll, rows = 4 }) => {
  return (
    <DynamicSkeleton
      rows={rows}
      columnConfig={columnConfig}
      infiniteScroll={infiniteScroll}
    />
  )
}

export default FeeSkeleton
